<mat-dialog-content>
    <app-productos-carrito></app-productos-carrito>
</mat-dialog-content>
<mat-dialog-actions align="end">
    <div style="display:flex;width:100%;justify-content: space-between;">
        <h3 class="my-0" *ngIf="globals.configuracion.front.cart.productos.length > 0"><strong>Total: </strong><span>{{ globals.configuracion.front.cart.total }}</span></h3>
        <button style="width:30%" mat-raised-button class="mb-1" color="accent" mat-dialog-close>Volver</button>
    </div>
    <div style="display:flex;width:100%;justify-content: space-between;margin-top:10px">

        <button style="width:50%" mat-raised-button class="mb-1" color="warn" *ngIf="globals.configuracion.front.cart.productos.length > 0 || globals.configuracion.front.cart.cotizacion_id != ''" mat-dialog-close (click)="cancelarCotizacion()">Limpiar Carrito</button>
        <button *ngIf="globals.configuracion.front.cart.productos.length > 0" mat-raised-button class="mb-1" style="background-color:#22b14d;color:white;width:50%" mat-dialog-close routerLink="/cotizar">Enviar Pedido</button>
    </div>

</mat-dialog-actions>